<div class="action-menu-cell">
  <button
    mat-icon-button
    [matMenuTriggerFor]="cellMenu"
    class="action-menu-trigger"
    [style.background-color]="params.backgroundColor"
    aria-label="Row actions"
    (click)="$event.stopPropagation()"
  >
    <span class="material-symbols-outlined">more_horiz</span>
  </button>

  <mat-menu #cellMenu="matMenu" xPosition="after" yPosition="below">
    @for (item of menuItems; track item.id) {
      <button mat-menu-item [disabled]="item.disableAction" (click)="onMenuItemClick(item)">
        <span class="options">@if(item.icon){<span class="material-symbols-outlined option-icons">{{ item.icon }}</span>}{{ item.label }}</span>
      </button>
    }
  </mat-menu>
</div>
